import styled from 'styled-components';
import { Flex, RectangularButton } from '@resideo/blueprint-react';
import ResideoLogo from './resideo-logo.svg?react';

export const HeaderContainer = styled(Flex)`
  background: black;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 80px;
  padding: 0 1rem;
  position: sticky;
  top: 0;
  z-index: var(--zidx-header);
`;

export const HeaderButton = styled(RectangularButton)`
  border-color: white;
  color: white;
  background-color: transparent;
  padding: 0 2.5em;
  font-weight: bold;
  border-width: 2px;
  :hover,
  :focus {
    background: white;
    color: black;
  }
`;

export const HeaderLogo = styled(ResideoLogo)`
  transform: scale(0.8);
  cursor: pointer;
`;
